
export const Unauthorized = props => {
    return <div style={{ fontWeight: "bold" }}>You are not authorized to view this page.</div>
}